export default __webpack_public_path__ + "static/media/a2.6d1b3e81.png";